import appHistory from './history';


/*******************************************************************************
 * Initial state
 */
const initialState = {
    routeLog: []
};


/*******************************************************************************
 * Non-async action types
 */
export const ROUTING_LOG_ROUTE = 'ROUTING_LOG_ROUTE';
export const ROUTING_CLEAR_LOG = 'ROUTING_CLEAR_LOG';


/*******************************************************************************
 * Reducer
 */
export default function routingData( state = initialState, action ) {
    switch ( action.type ) {
        case ROUTING_LOG_ROUTE:
            return {
                ...state,
                routeLog: [
                    ...state.routeLog,
                    action.path
                ]
            };
        case ROUTING_CLEAR_LOG:
            return {
                ...state,
                routeLog: []
            };
        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */
export function routeTo( path ) {
    return dispatch => {
        // Log the route
        dispatch( {
            type: ROUTING_LOG_ROUTE,
            path
        } );

        if ( appHistory && appHistory.location.pathname !== path ) {
            appHistory.push( path );
        }
    };
}

export const clearRoutingLog = () => (
    {
        type: ROUTING_CLEAR_LOG
    }
);
